import { useWizard } from '../../../context/WizardContext';
import { SubjectCard } from '../../../components/wizard/SubjectCard';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { getSubjects } from '../../../database/subjects';

export function Step1Subject() {
  const { state, setSubject } = useWizard();
  const availableSubjects = getSubjects(state.selectedClass, state.selectedDepartment);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Select a Subject</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose the subject for which you want to generate exam questions.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {availableSubjects.map((subject) => (
          <SubjectCard
            key={subject.id}
            subject={subject}
            isSelected={state.selectedSubject?.id === subject.id}
            onSelect={setSubject}
          />
        ))}
      </div>
      <NavigationButtons />
    </div>
  );
}
